module.exports = "/packs/images/general~19d24904cbf9a0ca819192411cadff15.svg";